/** @format */

import request from 'src/utils/request'

// 执行记录列表
export const getRecordList = async params => {
  const result = await request('/oos/?Action=ListSceneRecord&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Data || { Info: [], Total: 0 }
}

// 执行记录详情
export const getRecordDetail = async (ID: string) => {
  const result = await request('/oos/?Action=GetSceneRecord&Version=2025-01-01', {
    data: { ID },
    method: 'GET'
  })
  return result?.data?.Data || {}
}

// 查看执行进程
export const getRecordProcess = async (ID: string) => {
  const result = await request('/oos/?Action=GetSceneRecordProcess&Version=2025-01-01', {
    data: { ID },
    method: 'GET'
  })
  return result?.data?.Data || {}
}

// 保存日志
export const saveProcessLog = async params => {
  const result = await request('/oos/?Action=SaveWorkflowProcessLog&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 删除日志
export const deleteProcessLog = async params => {
  const result = await request('/oos/?Action=DeleteWorkflowProcessLog&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 获取进行评价信息
export const getEvaluateInfo = async (ID: number) => {
  const result = await request('/oos/?Action=GetSceneRecordEvaluate&Version=2025-01-01', {
    data: { ID },
    method: 'GET'
  })
  return result?.data?.Data
}

// 保存评价
export const saveEvaluate = async params => {
  const result = await request('/oos/?Action=SubmitSceneRecordEvaluate&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 终止执行记录
export const stopSceneRecord = async params => {
  const result = await request('/oos/?Action=StopSceneRecord&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 人工介入节点，选择通过
export const applyWorkflow = async params => {
  const result = await request('/oos/?Action=ApplyWorkflowProcessNode&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}

// 人工介入节点，催办
export const upgradeWorkflow = async params => {
  const result = await request('/oos/?Action=UpgradeWorkflowProcessNode&Version=2025-01-01', {
    data: params,
    method: 'POST'
  })
  return result?.data?.Code === 'success'
}
